import gql from 'graphql-tag'
import projectFragment from '../../fragments/project'

export default gql`mutation go($project_id: String!, $dates: [String]!){
  removeProjectFeeRates(project_id: $project_id, dates: $dates){
    ${projectFragment}
  }
}`